import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { TmProduct, TmProductSection, TmTellAFriendEmail } from '../model/product';
import { TmProductResults } from '../model/product-results';
import { ApiBase } from './apibase.service';


export class Products_RecentlyAired extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmProductResults> {
        return this.http
            .get(this.baseUrlv3 + '/products/recentlyaired', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmProductResults);
    }
}(Products_RecentlyAired as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_WhatsOnAir extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmProduct> {
        return this.http
            .get(this.baseUrlv3 + '/products/onairnow', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmProduct);
    }
}(Products_WhatsOnAir as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_TodayShowStopper extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmProductResults> {
        return this.http
            .get(this.baseUrlv3 + '/products/todayshowstopper', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmProductResults);
    }
}(Products_TodayShowStopper as any).ctorParameters = function () { return [ { type: Http } ]; }


export class ProductsByItemNos extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(itemNos: string): Observable<TmProductResults> {
        return this.http
            .get(this.baseUrlv3 + '/products/' + itemNos.trim(), { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmProductResults);
    }
}(ProductsByItemNos as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_Shares extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    post(itemNo: string, tmTellAFriendEmail: TmTellAFriendEmail): Observable<any> {
        let targetUrl: string = this.baseUrlv3 + '/products/' + itemNo.trim() + '/shares';
        return this.http.post(targetUrl, tmTellAFriendEmail, { headers: this.cachebleHeaders }).catch(this.handleError);
    }
}(Products_Shares as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(
        dimensions: string,
        searchTerm: string,
        page: number,
        pageSize: number,
        sortKey: string,
        visitorId: string,
        itemNos: string,
        rd: number,
        apiVersion3: boolean,
    ): Observable<TmProductResults> {
        let apiUrl = this.baseUrl + '/products';
        // change to v3 api url if apiVersion == 3
        if (apiVersion3) {
            apiUrl = this.baseUrlv3 + '/products';
        }
        let urlParams: URLSearchParams = new URLSearchParams();

        if (searchTerm != undefined && searchTerm.trim().length > 0) urlParams.set('searchTerm', searchTerm);

        if (dimensions != undefined && dimensions.length > 0) urlParams.set('dimensions', dimensions);

        if (page > 0) urlParams.set('page', page.toString());

        if (pageSize > 0) urlParams.set('pageSize', pageSize.toString());

        if (sortKey != undefined && sortKey.trim().length > 0) urlParams.set('sortKey', sortKey);

        if (visitorId != undefined && visitorId.trim().length > 0) urlParams.set('visitorId', visitorId);

        if (itemNos != undefined && itemNos.trim().length > 0) urlParams.set('itemNos', itemNos);

        urlParams.set('rd', rd.toString());

        let resp: any = this.http.get(apiUrl, { headers: this.cachebleHeaders, search: urlParams });
        resp = resp.map((r: Response) => r.json() as TmProductResults);
        return resp;
    }
}(Products as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_Sections extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(itemNo: string): Observable<TmProductSection[]> {
        return this.http
            .get(this.baseUrlv3 + '/products/' + itemNo.trim() + '/sections', { headers: this.cachebleHeaders })

            .map((r: Response) => r.json() as TmProductSection[]);
    }
}(Products_Sections as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_SectionsByTabOrder extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(itemNo: string, tabOrder: number): Observable<TmProductSection> {
        return this.http
            .get(this.baseUrlv3 + '/products/' + itemNo.trim() + '/sections/' + tabOrder.toString(), {
                headers: this.cachebleHeaders,
            })

            .map((r: Response) => r.json() as TmProductSection);
    }
}(Products_SectionsByTabOrder as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_StyleCodes extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }
    get(itemNo: string): Observable<string[]> {
        return this.http
            .get(this.baseUrlv3 + '/products/' + itemNo.trim() + '/styleCodes', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as string[]);
    }
}(Products_StyleCodes as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Products_Donation extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmProduct[]> {
        return this.http
            .get(this.baseUrlv3 + '/products/donation', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmProduct[]);
    }
}(Products_Donation as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/product.service.ts